import * as React from 'react';

import { Textarea } from '@/lib/ChatComponents/textarea';
import { cn } from '@/lib/utils';

type ChatInputProps = {} & React.TextareaHTMLAttributes<HTMLTextAreaElement>;

const ChatInput = React.forwardRef<HTMLTextAreaElement, ChatInputProps>(
    // eslint-disable-next-line react/prop-types
    ({ className, ...props }, ref) => (
        <Textarea
            autoComplete="off"
            ref={ref}
            name="message"
            className={cn(
                "bb:box-border bb:max-h-12 bb:px-4 bb:py-3 bb:bg-background bb:text-sm placeholder:bb:text-muted-foreground focus-visible:bb:outline-none focus-visible:bb:ring-ring disabled:bb:cursor-not-allowed disabled:bb:opacity-50 bb:w-full bb:rounded-md bb:flex bb:items-center bb:h-16 bb:resize-none",
                className,
            )}
            {...props}
        />
    ),
);
ChatInput.displayName = 'ChatInput';

export { ChatInput };
